import React from 'react';
import _ from 'lodash';
import { useRouter } from 'next/compat/router';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import useDispensarySpecials from 'src/dispensary/hooks/use-dispensary-specials';
import useRedirectMismatchedSpecialType from 'src/dispensary/hooks/use-redirect-mismatched-special-type';
import { useProductFiltersApplied } from 'src/hooks/use-product-filters-applied';

import Menu from 'components/menu';
import ContentWrapper from 'components/core/content-wrapper';

export default function SalePage() {
  const router = useRouter();
  const { dispensary } = useDispensary();
  const { specialId } = router?.query;

  const { products, totalPages, loading } = useDispensaryProducts({
    filters: { specialId, specialType: `sale`, isOnSpecial: true },
  });

  const { specials, loading: specialsLoading } = useDispensarySpecials({ specialId });
  useRedirectMismatchedSpecialType({
    router,
    ready: !specialsLoading && specials.length > 0,
    actualSpecialType: specials?.[0]?.specialType,
    expectedSpecialType: 'sale',
  });

  const productFiltersApplied = useProductFiltersApplied();
  const displaySidebar = !(_.isEmpty(products) && !productFiltersApplied);

  if (!dispensary) {
    return null;
  }

  // A POS-synced special card can render over an empty product grid when
  // `ecomm.specials.pos-discount-visible-weight.rollout` is enabled: the card gate (Armageddon
  // /rest/specials/has_products) cannot see option-threshold visibility, but filteredProducts
  // drops products whose discounted weights are all hidden. There is deliberately no
  // zero-product card guard here; the API emits
  // `ecomm.filtered_products.pos_discount_visible_weight_special_empty` when it happens, and
  // closing the gap needs the Armageddon probe to apply the same visibility rule.
  return (
    <ContentWrapper>
      <Menu
        products={products}
        loading={loading}
        dispensary={dispensary}
        page='sale special'
        specialId={specialId}
        specialType='sale'
        skipCurrentFilters
        totalPages={totalPages}
        displaySidebar={displaySidebar}
      />
    </ContentWrapper>
  );
}
